var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { DesktopSidebar } from "./DesktopSidebar";
import { MobileNavigation } from "./MobileNavigation";
import { useAppDispatch } from "@application/store/useStore";
import { logoutUser } from "@reducers/auth/thunk/auth";
import { useNavigate } from "react-router-dom";
const Sidebar = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield dispatch(logoutUser()).unwrap();
            navigate("/insight/login");
        }
        catch (error) {
            console.error("Logout failed:", error);
            navigate("/insight/login");
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DesktopSidebar, { onLogout: handleLogout }),
        React.createElement(MobileNavigation, { onLogout: handleLogout })));
};
export default Sidebar;
